import {DIMENSION_GRID} from "../../contants";

export const isRange = (row: number, col: number) =>
    row >= 0 && row < DIMENSION_GRID && col >= 0 && col < DIMENSION_GRID;
